import React, { useEffect, useState } from 'react'
import { NodeType } from 'shared/types/ingestion'
import { ContentFilterType, FilterType } from '../types'
import { Box } from '@mui/material'
import { InfoDisplay } from '../../../utility/Containers'
import { NodeTypeSelector } from '../../explore/NodeTypeSelector'
import { ContentFilter } from '../ContentFilter'
import { FilteredTreeTable } from '../FilteredTreeTable'
import { emptyNodeFilter } from './utility'

export function AllNodes({
  treeId,
  versionId,
}: {
  treeId: string
  versionId: string
}) {
  const [currentFilter, setCurrentCurrentFilter] = useState(emptyNodeFilter)
  const [nodeTypes, setNodeTypes] = useState<NodeType[]>([])
  const [contents, setContents] = useState<ContentFilterType>({})

  useEffect(() => {
    if (nodeTypes.length) {
      return setCurrentCurrentFilter({
        filterType: FilterType.node,
        typeSelections: {
          filterType: 'including',
          types: nodeTypes,
        },
      })
    }
    setCurrentCurrentFilter(emptyNodeFilter)
  }, [nodeTypes])

  return (
    <Box>
      <InfoDisplay>
        <Box>All Nodes</Box>
      </InfoDisplay>
      <Box>
        <NodeTypeSelector
          selectedTypes={nodeTypes}
          selectionChanged={(types) => {
            return setNodeTypes(types as NodeType[])
          }}
        />
      </Box>
      <Box>
        <ContentFilter
          contentFilters={contents}
          onFiltersChanged={(f) => setContents(f)}
        />
      </Box>
      <FilteredTreeTable
        filter={{
          ...currentFilter,
          withContent: contents,
        }}
        treeId={treeId}
        versionId={versionId}
        customColumns={[]}
      />
    </Box>
  )
}
